import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";
import { roleHasAccess } from "../utils/adminRoles";

const ModuleGate = ({ moduleId, children }) => {
  const { role, moduleAccess } = useAdminAuth();

  if (!roleHasAccess(role, moduleId, moduleAccess)) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default ModuleGate;
